import { render, staticRenderFns } from "./TradeFairEdits.vue?vue&type=template&id=2b684d98&lang=pug&"
import script from "./TradeFairEdits.vue?vue&type=script&lang=js&"
export * from "./TradeFairEdits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports